import React, {Component}     from 'react';
import {
  Button,
  Container,
  Divider,
  Header,
  Icon,
}                             from 'semantic-ui-react';
import _                      from 'lodash';
import ReactHtmlParser        from 'react-html-parser';
import PropTypes              from 'prop-types';
import BigCalendar            from 'react-big-calendar';
import moment                 from 'moment';
import ImmutablePropTypes     from 'react-immutable-proptypes';
import Immutable              from 'immutable';

// Global
import getMessage             from '../../global/getMessage';

// Molecule
import ToolBarCalendar        from '../../molecules/ToolBarCalendar';
import SgrModal               from '../../molecules/SgrModal';

// Controller
import MainCalendarController from './MainCalendarController';

// Style
import                    './MainCalendar.scss';

BigCalendar.momentLocalizer(moment); // Calendar Localization

const propTypes = {
  calendar    : ImmutablePropTypes.list,
  content     : PropTypes.arrayOf(PropTypes.object),
  getCalendar : PropTypes.func.isRequired,
  isLoading   : PropTypes.bool,
  lang        : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  calendar  : Immutable.List(),
  content   : null,
  isLoading : false,
  lang      : {},
};

class MainCalendar extends Component {

  constructor(props) {
    super(props);

    const minTime = new Date();
    minTime.setHours(9,0,0);

    const maxTime = new Date();
    maxTime.setHours(20,0,0);

    moment.locale('en');

    this.state = {
      minTime       : minTime,
      maxTime       : maxTime,
      selectedEvent : {},
    };

    this.setModalRef = this.setModalRef.bind(this);
    this.handleSelectEvent = this.handleSelectEvent.bind(this);
    this.modalref = null;
  }

  componentDidMount() {
    this.props.getCalendar();
  }

  setModalRef(ref) {
    this.modalref = ref;
  }

  handleSelectEvent(e) {
    const start = moment(e.start); // todays date
    const end = moment(e.end); // another date
    const duration = moment.duration(end.diff(start));
    const hours = duration.asHours();
    const minutes = duration.asMinutes();
    const startDate = moment(e.start).format('LLLL');
    const {lang} = this.props;

    const content = [
      (
        <React.Fragment key='1'>
          <h4>{getMessage('section.calendar.label.date',lang)}</h4>
          <p>
            {startDate}
          </p>
          <h4>{getMessage('section.calendar.label.duration', lang)}</h4>
          <p>
            {
              hours < 1 ?
                minutes + ' ' + getMessage('section.calendar.label.minutes', lang)
                :
                hours + ' ' + getMessage('section.calendar.label.hours', lang)
            }
          </p>
        </React.Fragment>
      ),
      (
        <React.Fragment key='2'>
          <h4>{getMessage('section.calendar.label.description', lang)}</h4>
          <p>
            {e.description || getMessage('section.calendar.label.noDescription', lang)}
          </p>
        </React.Fragment>
      ),
      (
        <React.Fragment key='3'>
          <h4>{getMessage('section.calendar.label.location', lang)}</h4>
          <p>
            {e.location || getMessage('section.calendar.label.noLocation', lang)}
          </p>
        </React.Fragment>
      ),
    ];

    const actions = e.actions ?
      (
        <Button primary>
          {'Proceed'}
          <Icon name='right chevron' />
        </Button>
      )
      :
      null;

    const selectedEvent = {
      header   : e.title,
      location : e.location || getMessage('section.calendar.label.noLocation', lang),
      content  : content,
      actions  : actions,
    };

    this.setState({selectedEvent}, () => this.modalref.open());
  }

  handleSelectSlot(slotInfo) {
    console.warn(`selected slot: \n\nstart ${slotInfo.start.toLocaleString()} ` +
    `\nend: ${slotInfo.end.toLocaleString()}` +
    `\naction: ${slotInfo.action}`);
  }

  render() {
    const {
      calendar,
      content,
      isLoading,
      lang,
    } = this.props;

    const contentMsg = content || getMessage('section.calendar.content', lang);
    const contents = [];

    _.forOwn(contentMsg, (value, key) => {
      contents.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    const {
      minTime,
      maxTime,
    } = this.state;

    isLoading;

    const {selectedEvent} = this.state;

    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>
            <Icon
              name='calendar'
              size='huge'
            />
            <br />
            {getMessage('section.calendar.header.title', lang)}
          </Header.Content>
          <Header.Subheader>
            {ReactHtmlParser(getMessage('section.calendar.header.subTitle', lang))}
          </Header.Subheader>
        </Header>

        <BigCalendar
          components={{toolbar: ToolBarCalendar}}
          defaultDate={new Date()}
          defaultView='week'
          events={calendar.toJS()}
          max={maxTime}
          min={minTime}
          onSelectEvent={this.handleSelectEvent}
          onSelectSlot={this.handleSelectSlot}
          selectable
          style={{height: '420px'}}
        />

        <SgrModal
          actions={selectedEvent.actions}
          content={selectedEvent.content}
          header={selectedEvent.header}
          ref={this.setModalRef}
        />

      </Container>
    );
  }

}

MainCalendar.propTypes = propTypes;
MainCalendar.defaultProps = defaultProps;

export default MainCalendarController(MainCalendar);



// WEBPACK FOOTER //
// ./src/organisms/MainCalendar/MainCalendar.js